export function applyStrategyStartTabPreference(
  switchToActivePositions: boolean,
  setActiveTab: (tab: number) => void,
): void {
  if (switchToActivePositions) {
    setActiveTab(0);
  }
}
